import { render, staticRenderFns } from "./Parser.vue?vue&type=template&id=b962061c&scoped=true&lang=html&"
import script from "./Parser.vue?vue&type=script&lang=js&"
export * from "./Parser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b962061c",
  null
  
)

export default component.exports